import { render, staticRenderFns } from "./SlotCheckboxList_comp.vue?vue&type=template&id=5a8c2716&scoped=true&"
import script from "./SlotCheckboxList_comp.vue?vue&type=script&lang=js&"
export * from "./SlotCheckboxList_comp.vue?vue&type=script&lang=js&"
import style0 from "./SlotCheckboxList_comp.vue?vue&type=style&index=0&id=5a8c2716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c2716",
  null
  
)

export default component.exports